import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import useLoginCheck from "./util/useLoginCheck";
import Spinner from "./util/Spinner";
import { fetchRandomQuote } from "./slice/randomQuoteSlice";
import { formatAuthors } from "./util/books";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { randomQuote, isLoading } = useSelector(
    (state) => state.randomQuote,
  );

  useLoginCheck();

  useEffect(() => {
    dispatch(fetchRandomQuote());
  }, [dispatch]);

  return (
    <div className="max-w-2xl mx-auto p-4 md:p-6 text-center">
      {isLoading ? (
        <Spinner />
      ) : randomQuote ? (
        <div>
          <p className="text-stone-800">{randomQuote.quote}</p>
          <p className="mt-2 text-stone-600">
            <span className="italic">{randomQuote.book?.title}, </span>
            {formatAuthors(randomQuote.book?.authors)}
          </p>
        </div>
      ) : (
        <p className="text-stone-500">No quotes entered</p>
      )}
    </div>
  );
};
export default Dashboard;
